<template>
    <div class="mb-1">
        <FixedPriceForSingleCategory
            v-if="attribute.name === 'fixed_price_for_single_category'"
            :attribute="attribute as FixedPriceForSingleCategoryRawAttribute"
        />
        <CategoryDefinedPrice
            v-else-if="attribute.name === 'category_defined_price'"
            :attribute="attribute as CategoryDefinedPriceRawAttribute"
        />
    </div>
</template>

<script setup lang="ts">
    import FixedPriceForSingleCategory from "./FixedPriceForSingleCategory.vue";
    import CategoryDefinedPrice from "./CategoryDefinedPrice.vue";
    import { CategoryDefinedPriceRawAttribute, FixedPriceForSingleCategoryRawAttribute } from "../../Common/Pricing/types";

    defineProps<{
        attribute: {
            name: string;
        };
    }>();
</script>

<style scoped></style>
